<script>

import TheGroupAttestation from "./TheGroupAttestation.vue";
import TheEducationalAttestationStatistics from "./TheEducationalAttestationStatistics.vue";
export default {
  name: "TheEducationAttestation",

  components: {
    TheGroupAttestation,
    TheEducationalAttestationStatistics
  },

  data() {
    return {
      tab: 0,
    };
  }
}
</script>

<template>
<v-app>
  <v-main>
    <v-tabs
      v-model="tab"
      grow
      color="teal darken-3"
    >

      <v-tab key="group"
      >
        По группе
      </v-tab>
      <v-tab key="educational"
      >
        По направлению
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item
        key="group"
      >
        <the-group-attestation/>
      </v-tab-item>
      <v-tab-item
        key="educational"
      >
        <the-educational-attestation-statistics/>
      </v-tab-item>
    </v-tabs-items>
  </v-main>
</v-app>
</template>

<style scoped>

</style>